'use strict';
import './picker.css'
//
import React from 'react';
import $, {extend} from 'jquery';
import classnames from 'classnames'

//
import Component from '../core/component';
import Enhance from '../core/enhance';
//
import {uuid} from '../libs/tools'

import Lang from '../common/lang';
import Iscroll from '../common/iscroll';

var animationEnd = 'animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd';

/**
 *
 */
class Picker extends Component {
    state = {
        hash: uuid()
    };

    constructor(props) {
        super(props);
        extend(this.state, props, true);

    }

    /**
     * 在componentWillMount()在挂载发生之前立即被调用。
     */
    componentWillMount() {
        this._on('popstate', this.handlerPopstate);
    }


    /**
     * 在组件从 DOM 中移除的时候立刻被调用。
     */
    componentWillUnmount() {
        this._un('popstate', this.handlerPopstate);
    }

    /**
     *shouldComponentUpdate(object nextProps, object nextState): boolean
     * 当组件做出是否要更新DOM的决定的时候被调用。
     * 实现该函数，优化this.props和nextProps，以及this.state和nextState的比较，
     * 如果不需要React更新DOM，则返回false。
     */
    shouldComponentUpdate(nextProps, nextState) {


        if (nextState.showChildren != this.state.showChildren && nextState.showChildren) {
            return true;
        }

        if (nextState.show != this.state.show && nextState.show)
            return true;

        if (this.state.show)
            return true;


        return false;
    }

    /**
     * 输入参数 nextProps 是即将被设置的属性，
     * 旧的属性还是可以通过 this.props 来获取。
     * 在这个回调函数里面，你可以根据属性的变化，
     * 通过调用 this.setState() 来更新你的组件状态，这里调用更新状态是安全的，
     * 并不会触发额外的 render() 调用
     */
    componentWillReceiveProps(nextProps) {
        extend(this.state, nextProps, true);
    }


    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
        //动画事件
        $(this.refs.animated).on(animationEnd, this.animationEnd);
    }

    /**
     *
     * @returns {XML}
     */
    render() {
        if (this.state.showChildren) {
            return (
                <div className={classnames("c-picker", this.props.className)}>
                    <div ref="popup" className={classnames("picker-modal", this.state.show ? 'modal-in' : 'modal-out')}
                         style={{display: 'block'}}>
                        <header className="bar bar-nav">
                            <button className="button button-link pull-right close-picker" onClick={this._handlerClose}>
                                <Lang lang="close"></Lang>
                            </button>
                            <h1 className="title">{this.state.title}</h1>
                        </header>
                        <div className={classnames("picker-modal-inner picker-items")}>
                            {this.state.children}
                        </div>
                    </div>
                    <div ref="overlay"
                         className={classnames("popup-overlay", this.state.show ? 'modal-overlay-visible' : '')}
                         onClick={this._handlerClose}></div>
                    <div ref="animated"
                         className={classnames("animated fast", this.state.show ? 'fadeIn' : 'fadeOut')}></div>
                </div>
            );
        } else {
            return null;
        }
    }


    handlerPopstate = () => {
        let hash = window.location.hash;
        if ('#' + this.state.hash === hash) {
            this.setState({showChildren: true}, () => {
                setTimeout(() => {
                    this.setState({show: true})
                }, 100);
            })
        } else {
            this.setState({show: false})
        }
    }


    /**
     *
     */
    animationEnd() {
    }


    /**
     *
     * @private
     */
    _handlerClose() {
        this.hide();
    }

    /**
     *
     */
    show() {
        window.location.hash = this.state.hash;
    }

    /**
     *
     */
    hide() {
        if ('#' + this.state.hash === window.location.hash) {
            window.history.back();
        }
    }


}

export default Enhance(Picker, {}, 'Picker')